import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { STAGES, PRIORITIES } from './crmConstants';

export function OverdueAlert({ count, onViewAll }) {
  if (count <= 0) return null;
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg px-4 py-3 mb-4 flex items-center gap-2" data-testid="overdue-alert">
      <AlertTriangle size={16} className="text-red-500" />
      <span className="text-sm font-sans text-red-700 font-medium">{count} follow-up{count > 1 ? 's' : ''} overdue</span>
      <button onClick={onViewAll} className="ml-auto text-xs text-red-500 font-sans font-semibold hover:underline" data-testid="overdue-view-all">View All</button>
    </div>
  );
}

export function PipelineSummary({ total, value, counts, onChange }) {
  return (
    <div className="flex gap-2 mb-4 overflow-x-auto pb-1" data-testid="pipeline-summary">
      <button
        onClick={() => onChange('all')}
        className={`flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-sans font-medium whitespace-nowrap transition-colors ${value === 'all' ? 'bg-earth-dark text-white' : 'bg-white border border-earth/15 text-earth/60 hover:border-saffron/30'}`}
        data-testid="filter-all"
      >
        All ({total})
      </button>
      {STAGES.map(s => {
        const active = value === s.key;
        return (
          <button
            key={s.key}
            onClick={() => onChange(active ? 'all' : s.key)}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-sans font-medium whitespace-nowrap transition-colors ${active ? 'text-white' : 'bg-white border border-earth/15 hover:border-saffron/30'}`}
            style={active ? { backgroundColor: s.color, color: '#fff' } : { color: s.color }}
            data-testid={`filter-${s.key}`}
          >
            <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: active ? '#fff' : s.color }} />
            {s.label} ({counts[s.key] || 0})
          </button>
        );
      })}
    </div>
  );
}

export function PriorityFilter({ value, onChange }) {
  return (
    <div className="flex gap-2 mb-4">
      {PRIORITIES.map(p => (
        <button
          key={p.key}
          onClick={() => onChange(p.key === value ? 'all' : p.key)}
          className={`flex items-center gap-1 px-2.5 py-1.5 rounded-md text-[10px] font-sans font-semibold transition-colors border ${value === p.key ? 'ring-2 ring-offset-1' : ''}`}
          style={{ backgroundColor: p.bg, color: p.color, borderColor: p.color + '30', '--tw-ring-color': p.color }}
          data-testid={`priority-filter-${p.key}`}
        >
          <p.icon size={10} /> {p.label}
        </button>
      ))}
      {value !== 'all' && (
        <button onClick={() => onChange('all')} className="text-[10px] text-earth/40 font-sans hover:text-earth/60" data-testid="priority-filter-clear">Clear</button>
      )}
    </div>
  );
}
